<template functional>
  <small class="stakeholder-helper text-tertiary cursor-pointer" v-on="listeners">
    <i class="fas fa-plus q-mr-sm" />
    {{ props.text }}
  </small>
</template>

<script>
export default {
  props: {
    text: String
  }
}
</script>
